var $11af101d9f91d300$exports = {};
$11af101d9f91d300$exports = {
    "valid": `Veljavno`
};


export {$11af101d9f91d300$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
